module.exports = __webpack_public_path__ + "assets/img/sfjy.75cbf108.jpg";